import { Component, Inject, ViewChild } from "@angular/core";
import {
  NavController,
  NavParams,
  ViewController,
  AlertController,
  LoadingController,
} from "ionic-angular";
import { FirebaseApp, AngularFire, FirebaseListObservable } from "angularfire2";
import { AssetService } from "../../providers/asset";
import { UiService } from "../../providers/ui";
import { HtmlEditor } from "../../components/html-editor/html-editor";
import { filter, findIndex } from "lodash";
import moment from "moment";

@Component({
  selector: "page-article",
  templateUrl: "article.html",
})
export class Article {
  @ViewChild(HtmlEditor) editor: HtmlEditor;

  // Loader
  loader: any = null;

  // Data
  firebaseApp: any = null;
  segmentModel: string = "English";
  articleModel: any = { photoURL: "", state: "draft" };
  editFlag: boolean = false;
  articles: FirebaseListObservable<any[]> = null;
  drafts: FirebaseListObservable<any[]> = null;
  usertypes: FirebaseListObservable<any[]> = null;

  notificationDefaults: any;

  constructor(
    @Inject(FirebaseApp) firebaseApp: any,
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public alertCtrl: AlertController,
    public loadingCtrl: LoadingController,
    public assetService: AssetService,
    public uiService: UiService,
    public af: AngularFire,
  ) {
    this.firebaseApp = firebaseApp;

    this.articleModel = JSON.parse(JSON.stringify(navParams.get("article")));
    this.editFlag = navParams.get("edit");

    this.articles = this.af.database.list(`/posts`);
    this.drafts = this.af.database.list(`/drafts`);
    this.usertypes = this.af.database.list("/usertypes");

    this.af.database.object("/settings/notifications/defaults")
      .subscribe(defaults => {
        console.log(defaults);
        this.notificationDefaults = defaults;
        this.articleModel.notification_title = defaults.article_title;
        this.articleModel.notification_body_mobile = defaults.article_body_mobile;
        this.articleModel.notification_body_email = defaults.article_body_email;
      })
  }

  dismissLoader() {
    if (this.loader) {
      this.loader.dismiss();
    }
  }

  dismiss() {
    this.dismissLoader();

    // setTimeout(() => {
    //   this.viewCtrl.dismiss();
    // }, 400);
  }

  presentLoading() {
    this.loader = this.loadingCtrl.create({
      dismissOnPageChange: true,
    });
    this.loader.present();
  }

  checkForMissingFields() {
    let requiredFields = [
      {fieldName: "title_en", fieldType: "string", title: "Title (English)"},
      {fieldName: "content_en", fieldType: "string", title: "Content (English)"},
      {fieldName: "photoURL", fieldType: "string", title: "Feature Image"},
      {fieldName: "notification_title", fieldType: "string", title: "Notification Title"},
      {fieldName: "notification_body_mobile", fieldType: "string", title: "Notification Body (Mobile)"},
      {fieldName: "notification_body_email", fieldType: "string", title: "Notification Body (Email)"},
    ];
    let missingFields = [];

    for (let i = 0; i < requiredFields.length; i++) {
      if (!this.articleModel.hasOwnProperty(requiredFields[i].fieldName)) {
        missingFields.push(requiredFields[i]);
        continue;
      }

      let fieldContent = this.articleModel[requiredFields[i].fieldName];
      if (typeof fieldContent === "undefined" || fieldContent === null) {
        missingFields.push(requiredFields[i]);
        continue;
      }
      if (
        requiredFields[i].fieldType === "string" &&
        !fieldContent.trim().length
      ) {
        missingFields.push(requiredFields[i]);
      }
    }

    return missingFields;
  }

  showAlert(message: string) {
    let alert = this.alertCtrl.create({
      title: "Harmonised",
      subTitle: message,
      buttons: ["OK"],
    });
    alert.present();
  }

  showMsg(message: string) {
    this.dismissLoader();

    setTimeout(() => {
      this.showAlert(message);
    }, 400);
  }

  showPromptConfirmation() {
    let prompt = this.alertCtrl.create({
      title: "Harmonised",
      subTitle: "Are you sure?",
      buttons: [
        {
          text: "Yes",
          handler: data => {
            try {
              // console.log("deleteArticle", this.articleModel);
              this.presentLoading();
              if (this.articleModel.id) {
                this.articles.remove(this.articleModel.id);
                this.drafts.remove(this.articleModel.id);
              }
              setTimeout(() => {
                this.dismiss();
              }, 600);
            } catch (error) {
              console.log("deleteArticle", error);
            }
          },
        },
        {
          text: "No",
        },
      ],
    });
    prompt.present();
  }

  deleteArticle() {
    this.showPromptConfirmation();
  }

  unpublish() {
    this.articleModel.state = "draft";
    this.saveArticle();
  }

  publishNow() {
    this.articleModel.state = "published";
    this.saveArticle();
  }

  saveArticle(message?: string) {
    try {
      this.presentLoading();

      // this.articleModel.content_en = this.quill_en.root.innerHTML;
      // this.articleModel.content_trm = this.quill_trm.root.innerHTML;

      console.log("saveArticle", this.articleModel);

      let missingFields = this.checkForMissingFields();
      if (missingFields && missingFields.length > 0) {
        let message = "<p>The below fields need to be filled:</p><ul>";
        missingFields.map(missingField => {
          message += `<li>${missingField.title}</li>`;
        });
        message += "</ul>";

        this.showMsg(message);

        return null;
      }

      // let selectedValues: any = filter(this.values, ['checked', true]);
      // if (selectedValues.length < 1) {
      //   this.showMsg('Please, choose one or more values.');
      //   return;
      // }

      // // Remove $ values
      // selectedValues.map( (val: any) => {
      //   delete val.$key;
      //   delete val.$exists;
      //   delete val.checked;
      // });

      // (<any>firebase).database.ServerValue.TIMESTAMP
      let tmpModel: any = {
        title_en: this.articleModel.title_en,
        subtitle_en: this.articleModel.subtitle_en || "",
        content_en: this.articleModel.content_en,
        title_trm: this.articleModel.title_trm || "",
        subtitle_trm: this.articleModel.subtitle_trm || "",
        content_trm: this.articleModel.content_trm || "",
        photoURL: this.articleModel.photoURL,
        notification_title: this.articleModel.notification_title,
        notification_body_mobile: this.articleModel.notification_body_mobile,
        notification_body_email: this.articleModel.notification_body_email,
        state: this.articleModel.state,
        username: this.af.auth.getAuth().auth.displayName || "AUT",
        type: "article",
        likes: this.articleModel.likes || 0,
        pinToFavourites: this.articleModel.pinToFavourites || "notPinned",
        timestamp: moment().unix(),
        usertype: this.articleModel.usertype || "",
      };

      console.log("articleModel - $key/id", this.articleModel.id);

      if (this.articleModel.state === "draft") {
        if (this.editFlag) {
          this.articles.remove(this.articleModel.id);
          this.drafts.update(this.articleModel.id, tmpModel);
        } else {
          this.drafts.push(tmpModel);
        }
      }

      if (this.articleModel.state === "published") {
        if (this.editFlag) {
          this.drafts.remove(this.articleModel.id);
          this.articles.remove(this.articleModel.id);
          this.articles.push(tmpModel).then(
            article => {
              this.articleModel.id = article.key;
              this.triggerNotifications();
            }
          );
        } else {
          this.articles.push(tmpModel).then(
            article => {
              this.articleModel.id = article.key;
              this.triggerNotifications();
            }
          );
        }
      }

      this.dismiss();
    } catch (error) {
      console.log("saveArticle", error);
    }
  }

  triggerNotifications() {
    this.af.database.list("notifications/").push({
      postId: this.articleModel.id,
      title: this.articleModel.notification_title,
      body_mobile: this.articleModel.notification_body_mobile,
      body_email: this.articleModel.notification_body_email,
      timestamp: moment().unix(),
      type: "global",
    });
  }

  // Event handlers
  onClose() {
    this.dismiss();
  }

  onSetArticleImage(event: any) {
    let loader = this.uiService.createLoader();

    return loader
      .present()
      .then(() => {
        return this.assetService.loadFileFromEvent(event);
      })
      .then(file => {
        return this.assetService.uploadArticleImage(file);
      })
      .then(uploadedFile => {
        this.articleModel.photoURL = uploadedFile.downloadURL;

        return loader.dismiss();
      })
      .catch(error => {
        return loader.dismiss().then(() => {
          return this.uiService.showAlert(
            "Whoops!",
            "Could upload selected image, please try again.",
          );
        });
      });
  }

  onTogglePinToFavourites(event: any) {
    console.log("onTogglePinToFavourites", event);
    this.articleModel.pinToFavourites = event.checked
      ? "pinnedToFavourites"
      : "notPinned";
  }

  onPhotoFromLibrary(pic: string) {
    this.articleModel.photoURL = `assets/images/library/${pic}.jpg`;
  }
}



// WEBPACK FOOTER //
// ./src/pages/article/article.ts